import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><strong parentName="p">{`If you are new to credit card churning`}</strong>{`: Please go read all of the resources on the /r/churning sidebar before starting to apply for cards. `}<strong parentName="p">{`If churning in 2-player mode, don't add your partner as an authorized user while under 5/24!`}</strong></p>
    <p><strong parentName="p">{`If you are just starting out with CCs in general/have a thin credit file`}</strong>{`, you will need to build credit history before going for the bigger cards listed in this guide.`}</p>
    <p>{`In that case, `}<strong parentName="p">{`the best starter cards`}</strong>{` (in my opinion) are the Chase Freedom and Discover It - get one (or both), use them responsibly for a year to build your credit history, and then you can start with the other cards in this guide.`}</p>
    <p><strong parentName="p">{`If you're a student`}</strong>{` and need to build credit history, the best starter cards are the Discover It Student and/or a Capital One student card. You might also be approved for a Chase Freedom, but you're almost guaranteed to be approved for Discover and Capital One student cards. (There's also a new Chase Freedom Student card, but it's definitely not as good as the Discover, and maybe not even as good as the Capital One.)`}</p>
    <p><strong parentName="p"><em parentName="strong">{`If denied, call recon. If denied again, HUCA!`}</em></strong></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      